import React from 'react';
interface SectionBadgeProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
}

/**
 * Section eyebrow styled like the "TOMO 3" label on the product covers:
 * letterspaced burgundy caps framed by thin gold rules.
 */
export function SectionBadge({
  children,
  className = ''
}: SectionBadgeProps) {
  return <span className={`inline-flex items-center gap-3 text-[11px] font-extrabold uppercase tracking-[0.24em] text-lime ${className}`} data-id="element-23" data-mp="1kb5mxrwpp34j">
      <span className="h-px w-6 bg-gold sm:w-10" aria-hidden="true" data-id="element-24" data-mp="1u2igqp22m3d7" />
      {children}
      <span className="h-px w-6 bg-gold sm:w-10" aria-hidden="true" data-id="element-25" data-mp="1u4w9usd6x5i4" />
    </span>;
}